const PROD = true

export default {
    defaultPath: '/dashboard',
    basename: '/', // only at build time to set, like /datta-able
    layout: 'vertical', // vertical, horizontal (not available in lite version)
    preLayout: null, // (not available in lite version)
    collapseMenu: false, // mini-menu
    layoutType: 'menu-light', // menu-dark, (menu-light, dark are not available in lite version)
    navIconColor: false,
    headerBackColor: 'header-default', // header-default, (header-blue, header-red, header-purple, header-lightblue, header-dark are not available in lite version)
    navBackColor: 'navbar-default', // navbar-default, (navbar-blue, navbar-red, navbar-purple, navbar-lightblue, navbar-dark are not available in lite version)
    navBrandColor: 'brand-default', // brand-default, (brand-blue, brand-red, brand-purple, brand-lightblue, brand-dark are not available in lite version)
    navBackImage: false, // not available in lite version
    rtlLayout: false, // not available in lite version
    navFixedLayout: true,
    headerFixedLayout: false, // not available in lite version
    boxLayout: false,
    navDropdownIcon: 'style1', // style1, (style2, style3 are not available in lite version)
    navListIcon: 'style1', // style1, (style2, style3, style4, style5, style6 are not available in lite version)
    navActiveListColor: 'active-default', // active-default, (active-blue, active-red, active-purple, active-lightblue, active-dark are not available in lite version)
    navListTitleColor: 'title-default', // title-default, (title-blue, title-red, title-purple, title-lightblue, title-dark are not available in lite version)
    navListTitleHide: false, // not available in lite version
    configBlock: false, // not available in lite version
    layout6Background : 'linear-gradient(to right, #A445B2 0%, #D41872 52%, #FF0066 100%)', // used only for pre-layout = layout-6
    layout6BackSize : '', // used only for pre-layout = layout-6
    DELHIVERY: {
        PINCODE_SERVICEABILITY: "checkPinCodeServiceAbility",
        ORDER: "createOrderForDelhivery", //"/api/cmu/create.json"
        WAREHOUSE: PROD ? "PET_PARADISE_MUMBAI" : "Pet_Paradise_STAGING",
        CL_PANEL_PRINT_PACKAGING_SLIP: "https://cl.delhivery.com/app/domestic/bulk-printing",
        PLACE_PICKUP_REQUEST: "placePickupRequest",
        ORDER_TRACKING_URL: "https://www.delhivery.com/track/package",
        TRACK_ORDER: "getCurrentOrderStatusFromDelhivery"
    },
    COLLECTIONS: {
        CATEGORIES: "categories",
        SUBCATEGORIES: "subCategories",
        PRODUCT_VARIANTS: "productVariants",
        PRODUCTS: "products",
        ORDERS: "orders",
        USERS: "users",
        ADDRESSES: "addresses",
        AVAILABLE_PIN_CODES: "availablePincode",
        BRANDS: "brands",
        DEALS: "deals",
        FEATURED_PRODUCTS: "featured_products"
    },
    DEALS_TYPE: {
        DEALS_OF_THE_DAY: "deals_of_the_day",
        FEATURED_PRODUCTS: "featured_products"
    },
    FILES: {
        PRODUCT_IMAGES: 'product-images',
        BRAND_IMAGES: 'brand-images',
        CATEGORY_IMAGES: 'category-images',
        DEALS_OF_THE_DAY_IMAGES: 'deals-of-the-day-images'
    },
    VARIANT_TYPE_VALUE_OPTIONS: [
        { label: "Button", value: "button"},
        { label: "Color", value: "color"}
    ],
    ORDER_STATUS: {
        initiated: {value: "initiated", label: "Initiated"},
        bid_initiated: {value: "bid_initiated", label: "Bid Initiated"},
        approved: {value: "approved", label: "Approved"},
        cancelled: {value: "cancelled", label: "Cancelled"},
        packaging: {value: "packaging", label: "Ready for Shipment"},
        in_transit: {value: "in_transit", label: "Shipment in Transit"},
        delivered: {value: "delivered", label: "Delivered"}
    },
    DELIVERY_TYPE: {
        delhivery: {value: "delhivery", label: "Delhivery", classes: "text-info"},
        manual: {value: "manual", label: "Manual", classes: "text-primary"}
    },
    DELHIVERY_STATUS: {
        UD: {value: "UD", label: "Undelivered", description: '"Undelivered" For forward Shipments'},
        DL: {value: "DL", label: "Delivered", description: '"Delivered" End status of Forward Shipments'},
        RT: {value: "RT", label: "Returned", description: '"Returned" For Returned Shipments'},
        PP: {value: "PP", label: "Pickup Pending", description: '"Pickup Pending" For RVP Shipments'},
        PU: {value: "PU", label: "Picked Up", description: '"Picked Up" RVP Shipments which are picked'},
        CN: {value: "CN", label: "Cancelled", description: '"Cancelled" RVP cancelled Shipments'}
    },
    DEFAULT_PAGE_SIZE: 10,
    USER: 'zoooptheapp_user1@gmail.com' // Zooop@123
};
